import React, { Component } from 'react';
import _ from 'lodash';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import Select from 'react-select';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import Modal from '../../components/modals';
import { toast } from 'react-toastify';
const getEvent = gql`
	query RootQuery($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			projectTitle

			name

			crew {
				count
				managerIds
				role
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			equipments {
				eqId
				qrCode
				status
				isReceived
				__typename
				userId
			}
		}
	}
`;
const getTenantUsersListForMc = gql`
	query VendorTenantUsersList($filters: TenantUsersFiltersInput) {
		vendorTenantUsersList(filters: $filters) {
			data {
				id
				firstName
				lastName
				email
				isEmailVerified
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
	}
`;
const getMemoryCard = gql`
	query MemoryCard($mcIdentifier: String) {
		memoryCard(mcIdentifier: $mcIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			manufacturerId
			manufacturer
			description
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdAt
			updatedBy
			updatedAt
			size
			isReceived
			subStatus
			branch {
				_id
				branchId
			}
		}
	}
`;
const assignMemoryCard = gql`
	mutation AssignMemoryCard(
		$qrCodes: [String!]!
		$workspaceId: String!
		$assignedTo: LogUserInput!
		$projectId: ID!
		$eventId: ID!
	) {
		assignMemoryCard(
			qrCodes: $qrCodes
			workspaceId: $workspaceId
			assignedTo: $assignedTo
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

class AsssignMemoryCards extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			qrCode: '',
			qrCodeError: false,
			qrCodeDuplicate: false,
			assignedCrew: null,
			tenantUsersList: {},
			eventDetails: {},
			equipments: [],
			isAssignedEquipmentLoading: false,
			showBusyModal: false,
		};
	}
	componentDidMount = () => {
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let json = {
			filters: {
				limit: 10000,
				page: 1,
				workspaceIds: this.props.params.workspaceID,
			},
		};
		this.getShootInfo(getEvent, filters);
		this.getTenantUsersListForMc(getTenantUsersListForMc, json);
	};
	renderCrew = () => {
		let crewDetails = [];
		_.map(this.state.eventDetails.crewNew, (crew) => {
			if (crew.isCustomUser !== true && crew.userId !== null) {
				let found = undefined;

				let name = '';
				let isManager = false;
				found = _.find(this.state.tenantUsersList, { id: crew.userId });
				if (found) {
					name = `${found.firstName ? found.firstName : ''}${' '}${
						found.lastName ? found.lastName : ''
					}`;
					isManager = crew.isManager === null ? false : crew.isManager;
				}

				let data = { id: crew.userId, name, isManager };

				crewDetails.push(data);
			}

			return crew;
		});

		let arr = [];
		_.forEach(crewDetails, (item, key) => {
			arr.push({ value: item.id, label: item.name });
		});
		return (
			<Select
				className={`cost-select-container zIndex3 w-100p `}
				classNamePrefix="cost-select"
				onChange={(e) => this.handleEditCrewName(e)}
				isSearchable={true}
				options={arr}
				value={
					_.filter(arr, {
						value: this.state.assignedCrew,
					})[0]
				}
			/>
		);
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedCrew: e.value,
			assignedCrewUserName: e.label,
		});
	};
	handleEventChange = (e, name) => {
		this.setState(
			{
				qrCode: e.target.value,
				qrCodeError: false,
				qrCodeErrorMessage: '',
			},
			async () => {
				if (_.size(this.state.qrCode.trim()) > 0 && e.target.value.length >= 8) {
					if (
						_.size(
							_.filter(this.state.equipments, {
								qrCode: e.target.value.toUpperCase(),
							}),
						) > 0
					) {
						this.setState({
							qrCodeError: true,
							qrCodeErrorMessage: '',
						});
					} else {
						let getMCVariables = {
							mcIdentifier: this.state.qrCode.toUpperCase(),
						};

						await this.getMemoryCardInfo(getMemoryCard, getMCVariables);
					}
				}
			},
		);
	};
	renderSummary = () => {
		let data = _.chain(this.state.equipments)
			.groupBy((x) => x.type)
			.map((value, key) => ({
				type: key,
				size: _.size(value),
				group: _.chain(value)
					.groupBy((x) => [x.manufacturer, x.size])
					.map((value, key) => ({ model: key, group: value }))
					.value(),
			}))
			.value();

		return data.length > 0
			? _.map(data, (item, key) => {
					return (
						<a>
							<h2>
								<p>{item.type}</p>
							</h2>
							<label>{item.size}</label>
							{_.map(item.group, (grp, k) => {
								return (
									<span>
										<h2>
											<p>{grp.model.replaceAll(',', ' ')}</p>
										</h2>{' '}
										<label>{_.size(grp.group)}</label>
									</span>
								);
							})}
						</a>
					);
			  })
			: '';
	};
	isDisabled = () => {
		if (
			_.size(this.state.equipments) == 0 ||
			this.state.assignedCrew == null ||
			(_.size(this.state.equipments) > 0 &&
				_.size(_.filter(this.state.equipments, { status: 'busy' })) > 0)
		) {
			return true;
		} else {
			return false;
		}
	};
	handleAssignEquipment = async (e) => {
		let eventId = this.props.params.shootID;
		let projectId = this.props.params.projectID;
		let workspaceId = this.props.params.workspaceID;
		let qrCodes = [];
		_.forEach(this.state.equipments, (equipment, key) => {
			qrCodes.push(equipment.qrCode);
		});
		let json = {
			qrCodes: qrCodes,
			assignedTo: {
				id: this.state.assignedCrew,
				name: this.state.assignedCrewUserName,
			},
			eventId,
			projectId,
			workspaceId,
		};

		let resp = await this.assignMemoryCard(assignMemoryCard, json);

		if (resp == false) {
			//this.handleCloseModal();
			toast.error('Cannot assign Memory Card to non verified users!', {
				position: 'top-right',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
		} else {
			toast.success('Memory Card Assigned Successfully!', {
				position: 'top-right',
				autoClose: 500,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			this.props.navigate(
				`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
			);
		}
	};
	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	goBack = (e) => {
		this.props.navigate(`/${this.props.params.vendorID}/shoots`);
	};
	handleBusyInfo = (mc) => {
		this.setState({
			showBusyModal: true,
			busyClickedMc: mc,
		});
	};
	render() {
		let busyCards;
		busyCards = _.filter(this.state.equipments, { status: 'busy' });

		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container">
						<div className="arc-header">
							{/* <div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div> */}
							<div className="arch-item">
								<span>Workspace</span>
								<b>{this.props.params.workspaceID}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Project</span>
								<b>{this.state.eventDetails.projectTitle}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Shoot</span>
								<b>{this.state.eventDetails.name}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Assign Memory Cards</span>
							</div>
						</div>
						<div className="arc-body">
							<div className="arcb-left">
								<div
									className="qrhitem column-20w"
									style={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<input
										value={this.state.qrCode}
										placeholder="Type QR Code"
										autoFocus={true}
										onChange={(e) => this.handleEventChange(e, 'qrCode')}
									/>
									{this.state.isEQFetching ? (
										<div className={'loading-btn'}>
											<LoadingBar />
										</div>
									) : (
										''
									)}
									{this.state.qrCodeError ? (
										<p>{this.state.qrCodeErrorMessage}</p>
									) : (
										''
									)}
								</div>
								<div className="arcbl-list">
									<div className="assign-hdd-item ">
										<div className="column column-20w">
											<span>QR Code</span>
											<span>description</span>
											<span>Ready to use</span>

											<span></span>

											{/* <span>damage</span> */}
										</div>

										{_.size(this.state.equipments) > 0 ? (
											_.map(
												this.state.equipments,

												(equipment, key) => {
													return (
														<div
															className="hitem column-20w listHitem"
															style={{
																color:
																	equipment.status === 'busy'
																		? 'red'
																		: '#fff',
															}}
														>
															<span
																style={{
																	display: 'flex',
																	alignItems: 'center',
																}}
																onClick={(e) =>
																	equipment.status === 'busy' &&
																	this.handleBusyInfo(equipment)
																}
															>
																{equipment.qrCode}
																{equipment.status === 'busy' ? (
																	<b
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			marginLeft: 5,
																		}}
																	>
																		<Info />
																	</b>
																) : (
																	''
																)}
															</span>
															<span
																onClick={(e) =>
																	equipment.status === 'busy' &&
																	this.handleBusyInfo(equipment)
																}
															>
																{equipment.description
																	? equipment.description
																	: (equipment.manufacturer
																			? equipment.manufacturer
																			: '') +
																	  ' ' +
																	  equipment.size +
																	  ' GB' +
																	  ' ' +
																	  equipment.type}
															</span>
															<span
																style={{
																	color:
																		equipment.status === 'busy'
																			? ''
																			: 'green !important',
																}}
																onClick={(e) =>
																	equipment.status === 'busy' &&
																	this.handleBusyInfo(equipment)
																}
															>
																{equipment.status === 'busy'
																	? 'No'
																	: 'Yes'}
															</span>

															<span
																onClick={(e) =>
																	this.deleteItem(
																		e,
																		equipment.qrCode,
																	)
																}
															>
																{' '}
																<Delete />
															</span>
														</div>
													);
												},
											)
										) : (
											<div className="empty">
												<p>
													No Memory Card Added <br />
													Please scan or type in the Memory Card ID
												</p>
											</div>
										)}
									</div>
								</div>
							</div>
							<div className="arcb-right">
								{/* <div className="arcbr-top-inputs">
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Workspace</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.props.params.workspaceID}
												//value={this.props.params.workspaceID}
												isDisabled={true}
											/>
										</div>
									</div>

									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Project</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.projectTitle}
												isDisabled={true}
											/>
										</div>
									</div>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Event</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.name}
												isDisabled={true}
											/>
										</div>
									</div>
								</div> */}
								<div className="arcbr-bottom-inputs" style={{ marginTop: 0 }}>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Assign To</label>
											{this.renderCrew()}
										</div>
									</div>
								</div>

								<div className="summary">
									<h3>Summary ({_.size(this.state.equipments)})</h3>
									{this.renderSummary()}
								</div>
								<div className="btn">
									{this.state.isAssignedEquipmentLoading === false ? (
										<a
											className={
												this.isDisabled()
													? 'add-edit-btn disabled'
													: 'add-edit-btn'
											}
											onClick={(e) => {
												if (!this.isDisabled()) {
													this.handleAssignEquipment();
												}
											}}
										>
											Assign Memory Cards
										</a>
									) : (
										<span className={'add-edit-btn loading-btn'}>
											<LoadingBar />
											Assign Memory Cards
										</span>
									)}
								</div>
							</div>
						</div>
						{this.state.showBusyModal === false ? null : (
							<Modal
								handleClose={() =>
									this.setState({ showBusyModal: false, busyClickedMc: null })
								}
								show={this.state.showBusyModal}
								modalType={'center'}
							>
								<div className="busy-modal">
									<div className="bm-header">MC Error</div>
									<div className="bm-body">
										<span>
											{this.state.busyClickedMc?.manufacturer}{' '}
											{this.state.busyClickedMc?.size + ' GB'}{' '}
											{this.state.busyClickedMc?.type} |{' '}
											{this.state.busyClickedMc?.qrCode} is already assigned
											to {this.state.busyClickedMc?.lastUsedBy.userName} for{' '}
											{this.state.busyClickedMc?.lastUsedBy.projectName}{' '}
											{this.state.busyClickedMc?.lastUsedBy.eventName}
										</span>
										<p>
											Please remove the above mentioned Memory card to
											complete the assignment.
										</p>
									</div>
									<div className="bm-footer">
										<a
											onClick={() =>
												this.setState({
													showBusyModal: false,
													busyClickedMc: null,
												})
											}
										>
											Okay, Got it
										</a>
									</div>
								</div>
							</Modal>
						)}
					</div>
				)}
			</>
		);
	}
}

export default withRouter(AsssignMemoryCards);
